import { render, staticRenderFns } from "./AdminPortinerieView.vue?vue&type=template&id=3cf36da1&"
import script from "./AdminPortinerieView.vue?vue&type=script&lang=ts&"
export * from "./AdminPortinerieView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports